import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import ReactModal from 'react-modal';

import styles from './whats-new-modal.css';

import picoblockGearIcon from '../menu-bar/picoblock-logo-small.svg';

const CHANGELOG = [
    {version: 'v1.0.0', items: [
        'New PiCoBlock gear logo and branding',
        'Responsive hardware panel — adapts to screen width',
        'Fixed code editor display on first load',
        'Improved device connection modal layout',
        'Updated all OpenBlock references to PiCoBlock'
    ]}
];

const WhatsNewModal = ({onClose}) => (
    <ReactModal
        isOpen
        className={styles.modal}
        overlayClassName={styles.overlay}
        onRequestClose={onClose}
    >
        <div className={styles.header}>
            <span className={styles.headerTitle}>
                {'PiCoBlock — '}
                <FormattedMessage
                    defaultMessage="What's New"
                    description="Title of the What's New modal"
                    id="gui.whatsNewModal.title"
                />
            </span>
            <button className={styles.closeButton} onClick={onClose}>✕</button>
        </div>
        <div className={styles.body}>
            {CHANGELOG.map(entry => (
                <div key={entry.version} className={styles.entry}>
                    <div className={styles.entryHeader}>
                        <div className={styles.iconWrap}>
                            <img
                                className={styles.icon}
                                src={picoblockGearIcon}
                                alt="PiCoBlock"
                                draggable={false}
                            />
                        </div>
                        <div className={styles.entryVersion}>{entry.version}</div>
                    </div>
                    <ul className={styles.changeList}>
                        {entry.items.map((item, i) => (
                            <li key={i} className={styles.changeItem}>{item}</li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
        <div className={styles.footer}>
            <button className={styles.doneButton} onClick={onClose}>
                <FormattedMessage
                    defaultMessage="Close"
                    description="Close button in What's New modal"
                    id="gui.whatsNewModal.close"
                />
            </button>
        </div>
    </ReactModal>
);

WhatsNewModal.propTypes = {
    onClose: PropTypes.func.isRequired
};

export default WhatsNewModal;
